const messageAgent = (phone, text, type = "_blank") => {
  const textWa = text || `Hi, saya ingin info lebih lanjut tentang properti ini:\n\n${window.location.href}\n\n_via ONE21 Customer Portal_`;

  const url = `https://api.whatsapp.com/send?text=${encodeURI(textWa)}&phone=${phone}`;

  window.open(url, type);
};

export default messageAgent